import { graphql } from "../graphql";
import mutation from "./mutation.gql";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { IRepoErrors } from "../errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";

export interface IDeleteInviteRequest {
  id: string;
  organizationId: string;
}

export async function deleteInvite(
  request: IDeleteInviteRequest
): Promise<boolean> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.mutate({
      mutation,
      variables: {
        inviteId: request.id,
        organizationId: request.organizationId,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new DeleteInviteError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);

    throw new DeleteInviteError(errors);
  }

  return response.data.deleteInvite;
}

export class DeleteInviteError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: DeleteInviteError");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};
